import { useSearchParams } from "react-router-dom";
import ResetPasswordForm from "../components/ResetPasswordForm";
import Layout from "../pages/Layout";
import { Helmet } from "react-helmet";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Extract token from URL

  return (
    <div className="reset-password-page">
      <Helmet>
              <title>Reset Password - Factbazaar</title>
              <meta name="description" content="Securely reset your password for Factbazaar. Enter your new password to regain access to your account." />
  <meta name="keywords" content="reset password, change password, forgot password, Factbazaar account recovery" />
  <meta name="author" content="Factbazaar Team" />
  <meta property="og:title" content="Reset Your Password - Factbazaar" />
  <meta property="og:description" content="Forgot your password? Use the link provided in your email to securely reset your password for Factbazaar." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.factbazaar.com/reset-password" />
  <meta property="og:image" content="https://www.factbazaar.com/logo.png" />
            </Helmet> 
      <Layout>
      {token ? (
        <ResetPasswordForm token={token} />
      ) : (
        <p>Invalid or missing token. Please check your email link.</p>
      )}
      </Layout>
    </div>
  );
};

export default ResetPassword;
